var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "white",
    stroke: "#E2E1F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1667 14.7144C22.3877 14.7144 22.5997 14.7972 22.7559 14.9445C22.9122 15.0918 23 15.2917 23 15.5C23 15.7083 22.9122 15.9082 22.7559 16.0555C22.5997 16.2028 22.3877 16.2856 22.1667 16.2856H10.8462L14.4242 19.6572C14.5806 19.8048 14.6685 20.0048 14.6685 20.2134C14.6685 20.422 14.5806 20.6221 14.4242 20.7696C14.2677 20.9171 14.0555 21 13.8342 21C13.613 21 13.4008 20.9171 13.2443 20.7696L8.2448 16.0562C8.1672 15.9832 8.10564 15.8965 8.06363 15.8011C8.02162 15.7056 8 15.6033 8 15.5C8 15.3967 8.02162 15.2944 8.06363 15.1989C8.10564 15.1035 8.1672 15.0168 8.2448 14.9438L13.2443 10.2304C13.4008 10.0829 13.613 10 13.8342 10C14.0555 10 14.2677 10.0829 14.4242 10.2304C14.5806 10.3779 14.6685 10.578 14.6685 10.7866C14.6685 10.9952 14.5806 11.1952 14.4242 11.3427L10.8462 14.7144H22.1667Z",
    fill: "#5B55FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageBack);
export default __webpack_public_path__ + "static/media/page_back.a39fa033a0fe2d427bd53dc59fab6a75.svg";
export { ForwardRef as ReactComponent };